import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Star = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="star icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M4.60476 23.7924C5.04784 24.1543 5.60979 24.03 6.27981 23.521L11.9966 19.1221L17.7243 23.521C18.3943 24.03 18.9455 24.1543 19.3993 23.7924C19.8424 23.4419 19.9397 22.8652 19.6695 22.0397L17.4109 15.006L23.1818 10.6636C23.8517 10.1661 24.122 9.64589 23.9491 9.08048C23.7762 8.53769 23.2682 8.26629 22.4361 8.2776L15.3575 8.32283L13.207 1.25521C12.9476 0.418402 12.5586 0 11.9966 0C11.4455 0 11.0564 0.418402 10.7971 1.25521L8.64652 8.32283L1.56803 8.2776C0.735904 8.26629 0.227982 8.53769 0.0550729 9.08048C-0.128643 9.64589 0.152335 10.1661 0.822359 10.6636L6.59322 15.006L4.33458 22.0397C4.06441 22.8652 4.16167 23.4419 4.60476 23.7924Z"
    />
  </svg>
)
